import { Children, useContext } from 'react';
import I18n from 'I18n';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const childrenToArray = children => {
  const result = [];
  Children.forEach(children, child => {
    result.push(child);
  });
  return result;
};
const listOptionKeys = new Set(['excessKey', 'exclusive', 'lastWordConnector', 'limit', 'locale', 'twoWordsConnector', 'wordsConnector']);
function FormattedList(props) {
  useContext(I18nHMRContext);
  const passThrough = {};
  Object.keys(props).forEach(key => {
    if (!listOptionKeys.has(key)) {
      // @ts-expect-error dynamic key access
      passThrough[key] = props[key];
    }
  });
  return /*#__PURE__*/_jsx("span", Object.assign({}, passThrough, {
    children: I18n.formatListArray(childrenToArray(props.children), props)
  }));
}
FormattedList.displayName = 'FormattedList';
export default FormattedList;